import type { CommonStrings } from './en';

const ar: CommonStrings = {
  language: 'اللغة',
  switchToLightTheme: 'التبديل إلى الوضع الفاتح',
  switchToDarkTheme: 'التبديل إلى الوضع الداكن',
  loadingMessages: 'جاري تحميل الرسائل.',
  loadingMessagesSr: 'جاري تحميل الرسائل.',
  connecting: 'جارٍ الاتصال…',
  noMessagesYet: 'لا توجد رسائل بعد',
  noMessagesYetBody: 'كن أول من يقول مرحباً!',
  skipToChat: 'انتقل إلى الدردشة',
  communityChat: 'دردشة المجتمع',
  results_one: 'نتيجة',
  results_other: 'نتائج',
  searchMessages: 'ابحث في الرسائل…',
  search: 'بحث',
  closeSearch: 'إغلاق البحث',
  loadEarlierMessages: 'تحميل الرسائل السابقة',
  loading: 'جارٍ التحميل…',
  copyMessage: 'نسخ الرسالة',
  copied: 'تم النسخ',
  replyToMessage: 'الرد على هذه الرسالة',
  editYourMessage: 'تعديل رسالتك',
  deleteYourMessage: 'حذف رسالتك',
  signOut: 'تسجيل الخروج',
  signingOut: 'جارٍ تسجيل الخروج…',
  signInTitle: 'تسجيل الدخول إلى AK-CHAT',
  welcomeTo: 'مرحباً بك في AK-CHAT',
  welcomeIntro:
    'دردشة مجتمع فورية لمتابعي وصديق AK01REDWAN. انضم إلى المحادثة، شارك التحديثات، وابقَ على اتصال.',
  continueWithGoogle: 'المتابعة باستخدام Google',
  signingIn: 'جارٍ تسجيل الدخول…',
  realTimeTitle: 'فوري',
  realTimeText: 'تظهر الرسائل فورياً للجميع في الغرفة.',
  reactionsRepliesTitle: 'تفاعلات وردود',
  reactionsRepliesText: 'تفاعل بالإيموجي واقتبس الرسائل التي تهمك.',
  yourDataTitle: 'بياناتك، قواعدك',
  yourDataText: 'يمكنك تعديل أو حذف أي شيء تنشره في أي وقت.',
  communityGuidelines: 'إرشادات المجتمع',
  cocPoint1: 'عامل الآخرين بلطف وتجنب اللغة المسيئة.',
  cocPoint2: 'التزم بموضوع أخبار وتحديثات AK01REDWAN.',
  cocPoint3: 'أبلغ عن أي انتهاكات للمشرفين.',
  cocDisclaimer: 'قد يؤدي عدم اتباع هذه الإرشادات إلى إنذارات أو تعليق أو حظر.',
  cocIntro: 'يرحب AK-CHAT بالجميع للدردشة ومشاركة التحديثات. يُتوقع سلوكٌ محترم:',
  cocOutro: 'قد يؤدي عدم اتباع هذه الإرشادات إلى إنذارات أو تعليق أو حظر. استمتع بوقتك في الدردشة!',
  iAgree: 'أوافق',
  delete: 'حذف',
  cancel: 'إلغاء',
  editMessage: 'تعديل الرسالة',
  editMessageAria: (name: string) => `تعديل رسالتك من ${name}`,
  editMessageFrom: (name: string) => `تعديل رسالتك من ${name}`,
  save: 'حفظ',
  saving: 'جارٍ الحفظ…',
  sending: 'جارٍ الإرسال…',
  deleteThisMessage: 'هل تريد حذف هذه الرسالة؟',
  deleteMessageBody: 'سيتم حذف هذه الرسالة نهائياً من الدردشة. لا يمكن التراجع عن هذا الإجراء.',
  replyTo: (name: string) => `الرد على ${name}`,
  replyingTo: (name: string) => `ردًا على ${name}`,
  cancelReply: 'إلغاء الرد',
  quickEmoji: 'إيموجي سريع',
  insertEmoji: (emoji: string) => `إدراج ${emoji}`,
  writeMessage: 'اكتب رسالة…',
  message: 'الرسالة',
  sendMessage: 'إرسال الرسالة',
  enterToSend: 'اضغط Enter للإرسال',
  anonymous: 'مجهول',
  noMatches: 'لا توجد نتائج',
  nothingFoundFor: (query: string) => `لم يتم العثور على شيء لـ “${query}”.`,
  today: 'اليوم',
  yesterday: 'أمس',
  online: (count: number) => `${count} متصل`,
  guest: 'ضيف',
  hi: (name: string) => `مرحبًا ${name}`,
  hiThere: 'مرحبًا بك',
  copiedTooltip: 'تم النسخ',
  copy: 'نسخ',
  reply: 'رد',
  edit: 'تعديل',
  removeYourReaction: (emoji: string) => `إزالة تفاعلك بـ ${emoji}`,
  reactWith: (emoji: string) => `التفاعل بـ ${emoji}`,
  people_one: 'شخص',
  people_other: 'أشخاص',
  youReacted: '، لقد تفاعلت',
  addReaction: 'إضافة تفاعل',
  chooseEmoji: 'اختر إيموجي',
  beKind: 'كن لطيفًا، التزم بالموضوع.',
  by: 'بواسطة',
  sendingDots: 'جارٍ الإرسال…',
  connectingDots: 'جارٍ الاتصال…',
  signingOutDots: 'جارٍ تسجيل الخروج…',
  signingInDots: 'جارٍ تسجيل الدخول…',
  offlineBanner: 'أنت غير متصل — سيتم إرسال الرسائل عند عودة الاتصال.',
  popupClosedNotError: 'تم إغلاق نافذة تسجيل الدخول — هذا ليس خطأ.',
  popupBlocked:
    'تم حظر نافذة تسجيل الدخول من قبل المتصفح. يرجى السماح بالنوافذ المنبثقة وإعادة المحاولة.',
  emailAccountExistsDifferent: 'يوجد حساب بنفس البريد الإلكتروني يستخدم طريقة تسجيل دخول مختلفة.',
  networkProblem: 'مشكلة في الشبكة. تحقق من اتصالك وحاول مرة أخرى.',
  tooManyAttempts: 'محاولات كثيرة جداً. انتظر لحظة ثم حاول مرة أخرى.',
  somethingWentWrongSignIn: 'حدث خطأ ما أثناء تسجيل الدخول.',
  cannotStart: 'لا يمكن تشغيل AK-CHAT',
  configHint: (envExample: string, envFile: string) =>
    `انسخ ${envExample} إلى ${envFile}، ثم املأ بيانات Firebase لتطبيق الويب، وأعد التشغيل. راجع دليل النشر للتفاصيل.`,
  firebaseNotConfigured: 'لم يتم تكوين Firebase.',
  reactionCount: (count: number) => String(count),
  messageTimeTitle: (date: string, time: string, ago: string) => `${date} ${time} • ${ago}`,
  messageEmpty: 'لا يمكن أن تكون الرسالة فارغة.',
  messageTooLong: (max: number) => `الرسائل محدودة بـ ${max} حرفًا.`,
  failedToUpdateMessage: 'فشل تحديث الرسالة.',
  failedToSend: 'فشل إرسال الرسالة.',
  failedToUpdateReaction: 'فشل تحديث التفاعل.',
  failedToDelete: 'فشل حذف الرسالة.',
  permissionDenied: 'permission-denied',
  signOutFailed: 'فشل تسجيل الخروج.',
};

export default ar;
